import React, { useState } from "react";

import { useFixedLayout } from "../../hooks/useFixedLayout";
import { SelectBoxB } from "./SelectGroup";

const TokenBizInfoPage = () => {
  const fixed = useFixedLayout();

  const [openTokenInfo, setOpenTokenInfo] = useState(true);
  const [openBizInfo, setOpenBizInfo] = useState(true);

  return (
    <div
      ref={fixed.containerRef}
      className="bg-surface-light-white"
    >

      <main className="px-[16px] pt-[40px]">
        {/* 1) 토큰 · 결제 유의사항 */}
        <section>
          <div className="pb-[12px]">            
            <SelectBoxB
              title="토큰 ∙ 결제 유의사항"
              isOpen={openTokenInfo}
              useToggleIcon
              titleClassName="text-t4"
              onClick={() => setOpenTokenInfo((prev) => !prev)}
            >
              <div className="p-[16px] space-y-[16px] text-b2 text-text-subtle">
                {/* 구매 안내 */}
                <div className="">
                  <p className="text-c1 text-text-subtle">구매 안내</p>
                  <ul className="text-c2 text-text-subtler pl-[4px] pt-[8px]">
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>표시된 금액은 부가가치세(VAT)가 포함된 최종 결제 금액입니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>결제가 정상적으로 완료되면 선택하신 수량의 토큰이 즉시 계정에 충전됩니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>토큰은 회원님의 계정에만 연결되며, 타인에게 양도·판매하거나 현금으로 교환할 수 없습니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>토큰은 이미지 생성 등 서비스의 유료 기능 이용 시 차감되며, 사용된 토큰은 다시 복구할 수 없습니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>토큰은 별도 안내가 없는 한 사용 기한이 없습니다. 다만 서비스 종료 또는 정책 변경이 필요한 경우, 사전 안내 후 적용됩니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>가격, 판매 구성, 프로모션은 사전 안내 후 변경될 수 있으며, 변경된 내용은 변경 이후 구매·충전분부터 적용됩니다.</span>
                    </li>
                  </ul>
                </div>

                {/* 환불 안내 */}
                <div className="">
                  <p className="text-c1 text-text-subtle">환불 안내</p>
                  <ul className="text-c2 text-text-subtler pl-[4px] pt-[8px]">
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>구매한 토큰을 한 번도 사용하지 않은 경우에 한해, 구매일로부터 7일 이내 환불을 요청하실 수 있습니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>토큰을 일부라도 사용하신 경우, 이미 생성된 이미지 및 사용된 토큰은 환불이 어렵습니다.</span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>
                        이벤트, 프로모션, 보너스로 지급된 토큰은 환불 대상에서 제외될 수 있습니다.
                      </span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>
                        환불은 사용 중인 플랫폼(예: 구글 플레이, 앱스토어)의 정책을 우선으로 하며, 국가·결제 수단에 따라 환불 가능 여부와 방법이 다를 수 있습니다.
                      </span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>
                        환불이 완료되면 해당 토큰은 회수되며, 토큰으로 생성한 일부 유료 콘텐츠 이용이 제한될 수 있습니다.
                      </span>
                    </li>
                    <li className="flex items-start gap-[6px]">
                      <span className="pt-[2px] leading-[1]">•</span>
                      <span>
                        도용·부정 결제 등 이상 거래가 확인될 경우, 이용 제한 및 결제 취소가 이루어질 수 있습니다.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </SelectBoxB>
            </div>
        </section>

        {/* 2) 제이예스(주) 사업자 정보 */}
        <section>
          <SelectBoxB
              title="제이예스(주) 사업자 정보 보기"
              isOpen={openBizInfo}
              useToggleIcon
              titleClassName="text-t4"
              onClick={() => setOpenBizInfo((prev) => !prev)}
            >
            <div className="px-[16px] py-[12px] text-c2">
              <div className="flex pb-[16px]">
                <div className="w-[92px] text-text-subtler shrink-0">상호명</div>
                <div className="text-text-subtle">제이예스 주식회사</div>
              </div>

              <div className="flex pb-[16px]">
                <div className="w-[92px] text-text-subtler shrink-0">대표이사</div>
                <div className="text-text-subtle">정용관</div>
              </div>

              <div className="flex pb-[16px]">
                <div className="w-[92px] text-text-subtler shrink-0">사업자등록번호</div>
                <div className="text-text-subtle">113-86-30615</div>
              </div>

              <div className="flex pb-[16px]">
                <div className="w-[92px] text-text-subtler shrink-0">법인번호</div>
                <div className="text-text-subtle">110111-4121143</div>
              </div>
              <div className="flex pb-[16px]">
                <div className="w-[92px] text-text-subtler shrink-0">주소</div>
                <div className="text-text-subtle">
                  서울시 영등포구 영등포동8가 92 knk 디지털타워 606호
                </div>
              </div>

              <div className="flex">
                <div className="w-[92px] text-text-subtler shrink-0">문의전화</div>
                <div className="text-text-subtle">
                  02-2655-9600(평일 : 10:00 ~ 17:00)
                </div>
              </div>
            </div>
          </SelectBoxB>
        </section>
      </main>
    </div>
  );
};

export default TokenBizInfoPage;
